import { gql } from '@apollo/client';
import { typeDefs as userTypeDefs } from '../../hooks/useUser';
import { typeDefs as cookiesTypeDefs } from '../../hooks/useCookies';
import { typeDefs as errorModalTypeDefs } from '../../hooks/useErrorModal';
import { typeDefs as paymentErrorTypeDefs } from '../../hooks/useCheckout/usePaymentError';
import { typeDefs as notificationTypeDefs } from '../../hooks/useNotifications';

export const localTypeDefs = gql`
  ${userTypeDefs}
  ${cookiesTypeDefs}
  ${errorModalTypeDefs}
  ${paymentErrorTypeDefs}
  ${notificationTypeDefs}

  extend type Query {
    cookies: Cookies
    user: User
    errorModal: ErrorModal
    paymentError: PaymentError
    notifications: [Notification!]!
  }
`;
